import { useMobileFiltersContext, ON_BOARDING_STATES } from './OnboardingContext'
import { FormOnBoardingButtons } from './OnboardingButtons'
import { FieldCheckBox } from './FieldCheckBox'

const NEXT_STEP = ON_BOARDING_STATES.BRANDS

/** SPORTS ARE DEFINED FROM A METAOBJECT AND ARE SET IN THE GM_STATE THIS DATA IS CURRENTLY NOT PRODUCTION READY */
const SPORTS = GM_STATE.metaobjects.omneo_sports ?? [
  { icon: 'bag', label: 'shopping', value: 'bag' },
  { icon: 'cart', label: 'cart', value: 'cart' },
  { icon: 'file', label: 'file', value: 'file' },
  { icon: 'fire', label: 'fire', value: 'fire' }
]

export function OnBoardingSports() {
  const context = useMobileFiltersContext()
  const currentChild = context.getCurrentChild()
  const [_, __, section] = currentChild?.steps ?? {}
  const selectedSports = section.sports.reduce((acc, sport) => ({ ...acc, [sport.value]: sport.id }), {})

  const handleNextStep = () => {
    context.handleNextStep(NEXT_STEP)
  }

  return (
    <form
      className={'flex flex-col gap-4'}
      onSubmit={(e) => {
        e.preventDefault()
        const formData = new FormData(e.currentTarget)
        const input = []
        formData.forEach((v, k) => {
          input.push({ value: v, id: k })
        })
        /** Have the fetch here to  */
        context.handleUpdateConfig({ sports: input })
        handleNextStep()
      }}
    >
      <div className={'grid grid-cols-1 gap-2 md:grid-cols-2'}>
        {SPORTS.map((sport) => {
          return (
            <FieldCheckBox
              {...{
                name: sport.label,
                value: sport.value,
                required: false,
                checked: selectedSports[sport.value]
              }}
            >
              <div className={'flex flex-row gap-4'}>
                <img src={sport.icon} className={'h-6 w-6 '} />

                {sport.label}
              </div>
            </FieldCheckBox>
          )
        })}
      </div>

      <FormOnBoardingButtons handleSkip={handleNextStep} />
    </form>
  )
}
